import { Citrus } from "lucide-react";

const ITEMS = ["Reset", "Refresh", "Rejuvenate", "Cold-Pressed Daily", "No Added Sugar", "Juiced With Love"];

export default function Marquee() {
  const row = (hidden) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center gap-10 pr-10">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center gap-10">
          <span className="whitespace-nowrap font-serif text-4xl font-medium italic text-cream md:text-6xl">
            {item}
          </span>
          <Citrus className="h-7 w-7 shrink-0 text-sun md:h-9 md:w-9" strokeWidth={1.5} />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="editorial-marquee" className="relative z-10 -mx-2 -rotate-1 overflow-hidden bg-leaf py-6 md:py-8">
      <div className="flex w-max animate-marquee">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
